export default function has2fa({ next, store }) {
  if (store.getters['auth/has2fa']) {
    next();
  } else if (store.getters['auth/loggedIn']) {
    next({ name: 'twofactorauthentication' });
  } else {
    next({ name: 'notFound' });
  }
}
